module.exports = __webpack_public_path__ + "img/journal-latest.bdf93d77.svg";